import { createSlice } from "@reduxjs/toolkit";
import { 
  getFifthFlow, 
  createFifthFlow, 
  updateFifthFlow, 
  deleteFifthFlow,
  clearLocalActiveFifthFlow
} from "./actions"; 

export const initialState = {
  fifthFlow: { 
    id: '', 
    email: '', 
    issue_email: '', 
    prompt: '', 
    updated_at: '' 
  },
  loading: false
};

const slice = createSlice({
  name: 'fifthFlows',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getFifthFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(getFifthFlow.fulfilled, (state, action) => {
        const { fifth_flow } = action.payload;
        const fifthFlow = { ...state.fifthFlow, ...fifth_flow };

        state.loading = false;
        state.fifthFlow = fifthFlow;
      })
      .addCase(getFifthFlow.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(createFifthFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(createFifthFlow.fulfilled, (state, action) => {
        const { fifth_flow } = action.payload;

        state.loading = false;
        state.fifthFlow = fifth_flow;       
      })
      .addCase(createFifthFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(updateFifthFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateFifthFlow.fulfilled, (state, action) => {
        const { status, fifth_flow } = action.payload;
        const updatedFifthFlow = { ...state.fifthFlow, ...fifth_flow };

        state.loading = false;
        if (status === 204) state.fifthFlow = updatedFifthFlow;       
      })
      .addCase(updateFifthFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(deleteFifthFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteFifthFlow.fulfilled, (state, action) => {
        const { status } = action.payload;

        state.loading = false;
        if (status === 204) state.fifthFlow = initialState.fifthFlow;       
      })
      .addCase(deleteFifthFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(clearLocalActiveFifthFlow, state => {
        state.fifthFlow = initialState.fifthFlow;
      })
  }
})

export default slice.reducer;